import PropTypes from 'prop-types';
import React from 'react';
import PhaseType from 'types/phase';

const appointment_started = ({ event: { kind, data: { auto } } }) =>
  <div className={kind}>
    {auto && 'Appointment Date reached. System has autocompleted task.'}
  </div>;

appointment_started.propTypes = {
  event: PropTypes.shape({
    kind: PropTypes.string.isRequired,
    data: PropTypes.shape({
      auto: PropTypes.bool,
    }).isRequired,
  }).isRequired,
  phase: PhaseType,
};

export {
  appointment_started as ready_to_measure,
  appointment_started as start_install,
  appointment_started as start_workorder,
};



// WEBPACK FOOTER //
// ./client/app/shared/components/PhaseHistoryCard/phaseEvents/appointment_started.jsx